var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hpc-tile",
      class: _vm.settings.showTextOnHover ? "hpc-tile--show-text-on-hover" : ""
    },
    [
      _c(
        "a",
        {
          staticClass: "hpc-tile__inner",
          attrs: { href: _vm.block.settings.tile_cta_link }
        },
        [
          _c("picture", [
            _c("source", {
              attrs: {
                srcset: _vm.imageSize(_vm.block.settings.tile_image, "800x"),
                media: "(min-width: 992px)"
              }
            }),
            _c("source", {
              attrs: {
                srcset: _vm.imageSize(_vm.block.settings.tile_image, "1024x"),
                media: "(min-width: 768px)"
              }
            }),
            _c("img", {
              staticClass: "hpc-tile__inner-image",
              attrs: {
                src: _vm.imageSize(_vm.block.settings.tile_image, "600x"),
                alt: _vm.block.settings.tile_header,
                loading: "lazy"
              }
            })
          ]),
          _c("div", { staticClass: "title-container fade-in-up-group" }, [
            _c(
              "h3",
              {
                staticClass: "hpc-tile__title col-12-sm col-8",
                class: _vm.settings.headerColor,
                style: { color: _vm.settings.headerColor }
              },
              [_vm._v(_vm._s(_vm.block.settings.tile_header))]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }